import React from "react";
import Dropdown from "../../dropdown/dropdown";

const DurationOption = ({ value }) => <div>{value}</div>;

const DurationSelect = ({
	durations,
	value,
	onSelect,
}: {
	durations: number[];
	value: number;
	onSelect: (duration: number) => void;
}) => {
	return (
		<Dropdown value={value} extraClass="durationDropdown" onItemSelect={onSelect}>
			{durations.map((duration, index) => (
				<DurationOption value={duration} key={index} />
			))}
		</Dropdown>
	);
};

export default DurationSelect;
